import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChangeReason } from '../model'
import { z } from 'zod'

const REASON_MIN_SYMBOLS = 3
const REASON_MAX_SYMBOLS = 255

/**
 * Initializes the form for editing a change reason
 * should replace the 'old' useChangeReasonFormInitializer after changing all the forms to zod
 * @param maxSymbols max allowed symbols for reason | 255
 * @param defaultReason default reason to show in form
 * @returns initialValues and validationSchema for changeReason form
 */
export const useChangeReasonFormInitializerZod = (
  maxSymbols = REASON_MAX_SYMBOLS,
  defaultReason = ''
): FormInitializerReturnTypeZod<ChangeReason, ChangeReason> => {
  const { t } = useCustomTranslation()
  const initialValues = { reason: defaultReason }

  const validationSchema = z.object({
    reason: z
      .string()
      .min(REASON_MIN_SYMBOLS, t(ValidationMessageKeys.lengthMin, { value: REASON_MIN_SYMBOLS }))
      .max(maxSymbols, t(ValidationMessageKeys.lengthMax, { value: maxSymbols }))
      .trim(),
  })
  return { initialValues, validationSchema }
}
